// Piedra Variant Scroll Handler
// This file handles variant selection and auto-scrolling to matching images

function togglePiedraMenu(el) {
  event.stopPropagation();
  const isOpen = el.classList.contains('is-open');
  document.querySelectorAll('.piedra-custom-dropdown').forEach(d => d.classList.remove('is-open'));
  if (!isOpen) el.classList.add('is-open');
}

function updatePiedraVariant(el, optionHandle, value) {
  console.log('🎯 updatePiedraVariant called with value:', value);
  
  event.stopPropagation();
  const dropdown = el.closest('.piedra-custom-dropdown');
  dropdown.querySelector('.piedra-selected-value').textContent = value;
  dropdown.classList.remove('is-open');

  const masterPicker = document.querySelector('variant-picker');
  console.log('  masterPicker found:', !!masterPicker);
  
  if (masterPicker) {
    const input = masterPicker.querySelector(`input[value="${value}"], option[value="${value}"]`);
    console.log('  input found:', !!input);
    
    if (input) {
      if (input.tagName === 'OPTION') {
        input.parentElement.value = value;
        input.parentElement.dispatchEvent(new Event('change', { bubbles: true }));
      } else {
        input.click();
      }
    }
  }

  // Scroll to matching image
  setTimeout(() => {
    scrollToImageByValue(value);
  }, 400);
}

function scrollToImageByValue(searchValue) {
  console.log('🔍 Looking for images matching:', searchValue);
  
  // Find all images in the gallery
  const allImages = document.querySelectorAll('img[alt]');
  console.log('📊 Total images found:', allImages.length);
  
  // Convert search value to lowercase for matching
  const searchLower = searchValue.toLowerCase();
  
  // Try to find matching image
  let matchingImage = null;
  for (let img of allImages) {
    const altLower = img.alt.toLowerCase();
    console.log('  Checking:', img.alt);
    
    // Exact match or partial match
    if (altLower === searchLower || altLower.includes(searchLower)) {
      // Make sure it's a reasonable size (not a tiny icon)
      const rect = img.getBoundingClientRect();
      if (rect.width > 100 && rect.height > 100) {
        matchingImage = img;
        console.log('✅ Found match:', img.alt);
        break;
      }
    }
  }
  
  if (matchingImage) {
    // Find the closest scrollable parent or use the image itself
    let scrollTarget = matchingImage.closest('.product-media') || 
                      matchingImage.closest('[class*="gallery"]') || 
                      matchingImage.closest('[class*="media"]') ||
                      matchingImage;
    
    console.log('🎬 Scrolling to:', matchingImage.alt);
    
    // Scroll smoothly with offset for header
    const headerOffset = -0.5;
    const elementPosition = scrollTarget.getBoundingClientRect().top + window.scrollY;
    const offsetPosition = elementPosition - headerOffset;
    
    window.scrollTo({
      top: offsetPosition,
      behavior: 'smooth'
    });
  } else {
    console.log('❌ No matching image found');
  }
}

// Close menu when clicking outside
window.addEventListener('click', () => {
  document.querySelectorAll('.piedra-custom-dropdown').forEach(d => d.classList.remove('is-open'));
});

console.log('✅ Piedra variant handler loaded');